import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CustomTable from "../../../../components/custom-table/custom-table";
import { MedicalPaOrder } from "../../../../data-model/medicalPaOrdersModel";
import { RootState } from "../../../../redux/store/store";
import { cptTableHeader, createCptCodesTableData } from "./cptCodesTable";

interface CptComponentCodesProps {
  cptCodesInfo?: MedicalPaOrder;
}

const CptComponentCodes = (props: CptComponentCodesProps) => {
  const [data, setData] = useState<any[]>([]);
  const { data: authStatusOptions } = useSelector(
    (state: RootState) => state.authStatusOptions,
  );
  useEffect(() => {
    if (props.cptCodesInfo) {
      setData(
        createCptCodesTableData(props?.cptCodesInfo, authStatusOptions ?? []),
      );
    }
  }, [props.cptCodesInfo, authStatusOptions]);
  return (
    <>
      <div className="cpt-codes--container flex flex-col gap-2">
        <div className="cpt-codes--header text-small font-bold leading-5">
          CPT Codes
        </div>
        <div className="cpt-codes--table">
          <CustomTable
            tableHeaders={cptTableHeader}
            hideSearchBar={true}
            count={data?.length}
            tableData={data}
            itemsPerPage={20}
            pagesPerView={3}
            hidePagination={true}
            tableName="cpt-codes"
          />
        </div>
      </div>
    </>
  );
};

export default CptComponentCodes;
